<template>
  <b-card class="selector-card">
    <div class="selector-row">
      <b-form-group
        label="Produto de Crédito"
        class="product-field"
      >
        <b-form-select
          :value="value"
          :options="options"
          @input="$emit('input', $event)"
        />
      </b-form-group>

      <b-button
        variant="primary"
        class="search-button"
        :disabled="!value"
        @click="$emit('search')"
      >
        Consultar
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormSelect,
  BButton
} from 'bootstrap-vue'

export default {
  name: 'CreditProductSelector',

  components: {
    BCard,
    BFormGroup,
    BFormSelect,
    BButton
  },

  props: {
    value: {
      type: [Number, String],
      default: null
    },

    options: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>
.selector-card {
  border: 0;
  border-radius: 8px;
}

.selector-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.product-field {
  flex: 1;
  margin-bottom: 0;
}
.custom-select:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 2px rgba(185, 183, 211, 0.712);
}

.search-button {
  height: 38px;
  min-width: 100px;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .selector-row {
    flex-direction: column;
    align-items: stretch;
  }

  .search-button {
    width: 100%;
  }
}
</style>